<template>
  <div>
    <b-alert :show="!!showAlert" v-html="showAlert" />
    <b-col cols="12" md="12" class="mt-2">
      <label for="">{{ $lang.attachFile }}</label>
      <fileDrag
        ref="fileDrag"
        @uploadFile="attachmentTemp"
        :acceptFormats="acceptFormats"
        :acceptFormatsInput="acceptFormatsInput"
        :multiple="false"
        :crop="false"
      />
      <div class="preview_file" v-if="fileUpload.length">
        <b-card :img-src="getImg(fileInfo)" img-alt="Card image" img-left>
          <b-card-text>
            <p>
              {{ fileInfo.name }}
              <span
                @click="removeFileProgress"
                class="float-right cursor-pointer"
                ><i class="fa fa-times fa-lg text-danger" aria-hidden="true"></i
              ></span>
            </p>
            <b-progress
              v-if="progress"
              :value="progress"
              :max="100"
              show-progress
              animated
            ></b-progress>
          </b-card-text>
        </b-card>
        <div v-if="errors" class="mt-2">
          <b-alert show variant="danger">
            <ul v-if="Array.isArray(errors)">
              <li
                v-for="(error, index) in errors"
                :key="index"
                v-html="error"
              />
            </ul>
            <span v-else v-html="errors" />
          </b-alert>
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="text-right mt-2">
      <b-button variant="outline-danger" class="mr-2" @click="closeModal">
        <mdicon name="close" size="20" />
        {{ $lang.close }}
      </b-button>
      <b-overlay
        :show="btnLoading || parentLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="success"
        class="d-inline-block"
      >
        <b-button
          variant="success"
          @click="submit"
          :disabled="fileUpload.length == 0"
        >
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-overlay>
    </b-col>
  </div>
</template>

<script>
import fileDrag from "./fileDrag";
export default {
  components: {
    fileDrag,
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    hasAppendData: {
      type: Boolean,
      default: false,
    },
    appendData: {
      type: Object,
      default: null,
    },
    isValidAppendData: {
      type: Boolean,
      default: true,
    },
    showAlert: {
      type: String,
      default: "",
    },
    acceptFormatsInput: {
      type: String,
      default:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    },
    fileKey: {
      type: String,
      default: "file",
    },
    acceptFormats: {
      type: Array,
      default: () => [
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
      ],
    },
    parentLoading: {
      type: Boolean,
      default: false,
    },
    uploadByCallback: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnLoading: false,
      errors: null,
      progress: 0,
      fileUpload: [],
      fileInfo: null,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    removeFileProgress() {
      this.errors = null;
      this.fileUpload = [];
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    getImg(file) {
      const fileType = file.type;
      const fileName = file.name.split(".")[1]; // get file by suffix name
      return fileType.match("image")
        ? URL.createObjectURL(file)
        : `/img/shared/file-icon/${fileName}.svg`;
    },
    attachmentTemp(files) {
      this.errors = null;
      this.btnHidden = true;
      this.fileUpload = files;
      const [file] = this.fileUpload;
      this.fileInfo = file;
    },
    submit() {
      if (this.uploadByCallback) {
        /* guidance: check parent data validation of parent component */
        if (!this.isValidAppendData) return;
        this.$emit("submit", () => this.uploadFile());
      } else {
        this.$emit("submit");
        /* guidance: check parent data validation of parent component */
        if (!this.isValidAppendData) return;
        this.uploadFile();
      }
    },
    async uploadFile() {
      try {
        this.btnLoading = true;
        this.errors = null;
        let formData = new FormData();
        formData.append(this.fileKey, this.fileInfo);

        /* guidance: add parent data to payload */
        if (this.hasAppendData && this.appendData) {
          const data = Object.keys(this.appendData);
          for (const key of data) {
            formData.append(key, this.appendData[key]);
          }
        }

        const response = await this.$httpService.post(
          this.url,
          formData,
          {
            "Content-Type": "multipart/form-data",
          },
          true,
          {
            onUploadProgress: function (e) {
              this.progress = parseInt(Math.round((e.loaded * 100) / e.total));
            }.bind(this),
          }
        );
        this.$notify.success(response.data.message);
        this.fileUpload = [];
        this.closeModal();
        this.$emit("getItems");
      } catch (error) {
        if (error.response.status === 400) {
          this.errors = error.response.data.message;
        } else {
          this.$generateError(error);
        }
      } finally {
        this.progress = 0;
        this.btnLoading = false;
      }
    },
  },
};
</script>
